import humps from 'humps'

export const camelCase = (val) => (humps.camelize(val))
export const snakeCase = (val) => (humps.decamelize(val))
export const camelCaseKeys = (obj) => (humps.camelizeKeys(obj))
export const snakeCaseKeys = (obj) => (humps.decamelizeKeys(obj))
